
import Typography from '@/ui-kit/components/typography';
import Gutter from '@/ui-kit/components/gutter';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import {
  StyleFontWeightType,
  StyleSizeType,
  StyleColorSchemeType,
  StylePositionType,
} from '@/ui-kit/styles/enums';
import CarouselItem from '@/ui-kit/components/carousel-item';
import { Comparator } from '@/ui-kit/enums';
import { Breakpoints } from '@/ui-kit/styles/constants';
import Icon from '@/ui-kit/components/icon';
import { IconType } from '@/ui-kit/components/icon/enums';
import LazyImage from '@/components/lazy-image';
import ImageHelper from '@/utils/ImageHelper';

export default {
  name: 'WhoWeAreFooterSectionCarouselItem',
  components: {
    CarouselItem,
    LazyImage,
    Typography,
    Gutter,
    Icon,
  },
  props: {
    image: {
      default: () => ({}),
      type: Object,
    },
    slideTitle: {
      default: '',
      type: String,
    },
    title: {
      default: '',
      type: String,
    },
    description: {
      default: '',
      type: String,
    },
    name: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      TypographyType,
      StyleFontWeightType,
      StyleSizeType,
      StyleColorSchemeType,
      StylePositionType,
      IconType,
    };
  },
  computed: {
    imageRatio() {
      return ImageHelper.constructor.getImageRatio(this.image.dimensions);
    },
    carouselImageSizes() {
      return [
        {
          comparator: Comparator.Less,
          breakpoint: Breakpoints.XSmall,
          imageSize: 400,
        },
        {
          comparator: Comparator.Less,
          breakpoint: Breakpoints.Small,
          imageSize: 600,
        },
        {
          comparator: Comparator.Greater,
          breakpoint: Breakpoints.Medium,
          imageSize: 700,
        },
      ];
    },
  },
};
